<template>
  <rs-select
    :label="label"
    :items="options"
    v-bind="$attrs"
    v-on="$listeners"
    hide-details="auto"
  />
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    clusterId: {
      type: Number,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: "Banka Hesabı",
    },
    isActive: {
      type: Boolean,
      required: false,
      default: null,
    },
    selectFirst: {
      type: Boolean,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["cluster"]),
  },
  watch: {
    cluster() {
      this.loadList();
    },
    clusterId() {
      this.loadList();
    },
  },
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.cluster) {
        this.loadList();
      }
    });
  },
  methods: {
    loadList() {
      const clusterId = this.clusterId || this.cluster.id;
      const params = { cluster_id: clusterId, per_page: 100 };
      this.options = [];

      if (this.isActive) {
        params.is_active = true;
      }

      this.$api
        .query("budgets", { params })
        .then((response) => {
          if (response.data.data) {
            this.options = response.data.data;

            if (this.selectFirst && this.options.length) {
              setTimeout(() => {
                this.$emit("input", this.options[0].id);
                this.$emit("change", this.options[0].id);
              });
            }
          } else {
            throw new Error("Budgets not retrieved");
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
  },
};
</script>
